import React, { useEffect } from "react";
import "./salesAutomation.css";
import communication from "assets/contactManagement/communication.png";
import satisfaction from "assets/contactManagement/satisfaction.png";
import email_analytics from "assets/contactManagement/email_analytics.png";
import social from "assets/contactManagement/social.png";
import get_in_touch from "assets/contactManagement/get_in_touch.png";
import calling from "assets/contactManagement/calling.png";
import meeting from "assets/contactManagement/meeting.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const ContactManagement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Contact Management | The Realtor Desk" description="" />
      <div className="sub-page--outer">
          <SubPageHeader
              title="Foster Strong Customer Relationships"
              subTitle="Turn your customers into brand ambassadors. With multichannel communication capabilities, Realtor CRM enables you to exceed customer expectations every time they reach out, ensuring a seamless and exceptional experience."
          />
          <div className="container">
              <ImageWithTextBlock
                  shortTitle=""
                  title="Communicate Across Channels"
                  description="Engage with your customers seamlessly through multiple channels, including email, phone, SMS, and social media, all integrated into one platform."
                  image={communication}
                  imagePosition="right"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="Complete Customer Satisfaction"
                  description="Realtor CRM integrates seamlessly with help desk software like Zendesk, Salesforce Desk, and Zoho Desk. With two-way CRM and help desk integration, customer tickets are synced with relevant sales data, enabling your teams to deliver a consistent and exceptional customer experience."
                  image={satisfaction}
                  imagePosition="left"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="Email, Insights, and More—Powered by CRM"
                  description="Use powerful analytics to optimize your email campaigns. Identify the best days to send emails, analyze open rates, and determine which templates drive the most engagement. Integrate your preferred email platform with Realtor CRM for seamless and effective communication."
                  image={email_analytics}
                  imagePosition="right"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="Get Social with Prospects and Customers"
                  description="Receive and segment notifications for posts and messages from leads, prospects, and customers. Engage in conversations across Twitter and Facebook directly from within Realtor CRM for seamless interaction."
                  image={social}
                  imagePosition="left"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="Know When to Get in Touch"
                  description="Whether resolving a support query or pitching a new cross-selling opportunity, ensure your calls are answered. With insights from past interactions, CRM assistant suggests the best times to connect with your customers effectively."
                  image={get_in_touch}
                  imagePosition="right"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="One-Click Calling"
                  description="Realtor CRM provides over 50 native telephony integrations, allowing seamless customer calls with just one click. Access a 360-degree view of customer information during calls and generate detailed call reports to evaluate the performance of your sales and support teams."
                  image={calling}
                  imagePosition="left"
              />
              <ImageWithTextBlock
                  shortTitle=""
                  title="Log Meetings with Customers"
                  description="Utilize the check-in feature on the mobile app to record meetings with customers. Keep your team informed by notifying colleagues, ensuring they can follow up and take the next steps with the prospect or customer."
                  image={meeting}
                  imagePosition="right"
              />
          </div>
      </div>
    </>
  );
};

export default ContactManagement;
